<div class="d-flex justify-content-between align-items-center px-3 border-bottom border-light shadow-sm modal-header-fixed">
  <h2 class="mb-0 ms-2 fw-bold">Leyenda de impresión en la acta administrativa</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon fontIcon="close"></mat-icon>
  </button>
</div>

<div *ngIf="estaCargando">
  <div class="text-center py-5">
    <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center py-5">
    <span>Cargando datos...</span>
  </div>
</div>
<div *ngIf="!estaCargando">
  <mat-dialog-content class="overflow-hidden pb-0 pt-2">
    <div class="row g-2">
      <div class="col-12">
        <h3 class="text-decoration-underline mb-0 text-center fw-bolder text-dark m-0">ACTA ADMINISTRATIVA POR FALTAS</h3>
      </div>

      <div class="col-12">
        <textarea readonly [(ngModel)]="cuerpoActa.leyenda" class="form-control bg-light" style="min-height: 9lh;"></textarea>
      </div>

      <div class="col-6">
        <label class="mb-0 text-start">Nombre del trabajador</label>
        <ng-select [items]="empleados" [(ngModel)]="empleadoSeleccionado" bindLabel="nombreCompleto" notFoundText="Empleado no encontrado" placeholder="Seleccione al trabajador" appendTo="body" dropdownPosition="auto">
          <ng-template ng-option-tmp let-item="item">
            {{ nombreCompleto(item) }}
          </ng-template>
        </ng-select>
      </div>

      <div class="col-6">
        <label class="mb-0 text-start">Fecha de la falta</label>
        <input type="date" [(ngModel)]="fechaFalta" class="form-control">
      </div>

      <div class="col-4">
        <label class="mb-0 text-start">Representante legal</label>
        <ng-select [items]="empleadosRepresentantes" [(ngModel)]="empleadoRepresentanteSeleccionado" bindLabel="nombreCompleto" notFoundText="Empleado no encontrado" placeholder="Seleccione al representante legal" appendTo="body" dropdownPosition="auto">
          <ng-template ng-option-tmp let-item="item">
            {{ nombreCompleto(item) }}
          </ng-template>
        </ng-select>
      </div>

      <div class="col-4">
        <label class="mb-0 text-start">Testigo 1</label>
        <ng-select [items]="empleados" [(ngModel)]="empleadoTestigo1" bindLabel="nombreCompleto" notFoundText="Empleado no encontrado" placeholder="Seleccione al testigo 1" appendTo="body" dropdownPosition="auto">
          <ng-template ng-option-tmp let-item="item">
            {{ nombreCompleto(item) }}
          </ng-template>
        </ng-select>
      </div>

      <div class="col-4">
        <label class="mb-0 text-start">Testigo 2</label>
        <ng-select [items]="empleados" [(ngModel)]="empleadoTestigo2" bindLabel="nombreCompleto" notFoundText="Empleado no encontrado" placeholder="Seleccione al testigo 2" appendTo="body" dropdownPosition="auto">
          <ng-template ng-option-tmp let-item="item">
            {{ nombreCompleto(item) }}
          </ng-template>
        </ng-select>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-between">
    <div class="form-check mx-2">
      <input class="form-check-input" type="checkbox" id="nombresUpper" [(ngModel)]="nombresUpper">
      <label class="form-check-label fw-bold" for="nombresUpper">Mostrar nombres en mayúsculas</label>
    </div>

    <div>
      <button mat-raised-button class="text-primary mx-2" (click)="exportarPDF()">Descargar documento</button>
    </div>
  </mat-dialog-actions>
</div>
